import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BaseForm } from '@app/components/common/forms/BaseForm/BaseForm';
import { useAppDispatch } from '@app/hooks/reduxHooks';
import { doLogin } from '@app/store/slices/authSlice';
import { notificationController } from '@app/controllers/notificationController';

import * as Auth from '@app/components/layouts/AuthLayout/AuthLayout.styles';

interface LoginFormData {
  email: string;
  password: string;
}

export const initValues: LoginFormData = {
  email: '',
  password: '',
  // email: 'admin@example.com',
  // password: 'admin123',
};

export const LoginForm: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (values: LoginFormData) => {
    setLoading(true);
    setError('');
    try {
      console.log('开始登录...');
      // 执行登录
      await dispatch(doLogin(values));
          
      navigate('/');
    } catch (err: any) {
      console.error('登录失败:', err);
      setError(err.message || '登录失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Auth.FormWrapper>
      <BaseForm layout="vertical" onFinish={handleSubmit} requiredMark="optional" initialValues={initValues}>
        <Auth.FormTitle>登录</Auth.FormTitle>
        {/* <S.LoginDescription>{t('login.loginInfo')}</S.LoginDescription> */}
        {error && (
          <Auth.FormItem>
            <span style={{ color: '#ff4d4f' }}>{error}</span>
          </Auth.FormItem>
        )}
        <Auth.FormItem
          name="email"
          label={'邮箱'}
          rules={[
            { required: true, message: t('请输入邮箱') },
            {
              type: 'email',
              message: '请输入正确的邮箱格式',
            },
          ]}
        >
          <Auth.FormInput placeholder={'邮箱'} />
        </Auth.FormItem>
        <Auth.FormItem
          label={'密码'}
          name="password"
          rules={[{ required: true, message: '请输入密码' }]}
        >
          <Auth.FormInputPassword placeholder={'密码'} />
        </Auth.FormItem>
        <BaseForm.Item noStyle>
          <Auth.SubmitButton type="primary" htmlType="submit" loading={loading}>
            登录
          </Auth.SubmitButton>
        </BaseForm.Item>
      </BaseForm>
    </Auth.FormWrapper>
  );
};
